import { isCleaningReference } from '@front/common/src/utils/universes';
import { UniverseReference } from '@front/common/src/types/commons';
import { useBooleanVariant } from '@front/common/src/providers/experiment-provider';

export type UseInstantTaxCreditCleaningFunnelVariantArgs = {
  universe?: UniverseReference;
};

export const useInstantTaxCreditCleaningFunnelVariant = ({
  universe,
}: UseInstantTaxCreditCleaningFunnelVariantArgs) =>
  useBooleanVariant('cst-cleaning-instant-tax-credit-funnel') && isCleaningReference(universe);
